import svg from "./notification-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const NotificationIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.emphasis.main,
);

export default NotificationIcon;
